import React, { FC, useMemo } from 'react';
import {
  UpTrendIcon,
  ScoreTrendCont,
  Sign,
  DownTrendIcon,
  NoTrendIcon,
  ScoreTrendContent,
} from './ScoreTrend.styles';
import { THEME as theme } from '../../styles/theme';

interface IProgressArrow {
  progress: number;
  stateType?: 'positive' | 'negative';
  isBorderless?: boolean;
}

const ScoreTrend: FC<IProgressArrow> = ({ progress, stateType, isBorderless = false }) => {
  const renderTrend = useMemo(() => {
    const states = {
      negative: {
        color: theme.colors.accent.red[100],
        backgroundColor: theme.colors.accent.red[10],
        arrow:
          progress > 0 ? (
            <UpTrendIcon
              id="UpTrendIcon"
              data-testid="upTrendIcon"
              color={theme.colors.accent.red[100]}
            />
          ) : (
            <DownTrendIcon
              id="DownTrendIcon"
              data-testid="downTrendIcon"
              color={theme.colors.accent.red[100]}
            />
          ),
        sign: progress > 0 ? '+' : '-',
      },
      positive: {
        color: theme.colors.accent.green[100],
        backgroundColor: theme.colors.accent.green[10],
        arrow:
          progress > 0 ? (
            <UpTrendIcon
              id="UpTrendIcon"
              data-testid="upTrendIcon"
              color={theme.colors.accent.green[100]}
            />
          ) : (
            <DownTrendIcon
              id="DownTrendIcon"
              data-testid="downTrendIcon"
              color={theme.colors.accent.green[100]}
            />
          ),
        sign: progress > 0 ? '+' : '-',
      },
    };

    return (
      (stateType && states[stateType]) ?? {
        color: theme.colors.accent.blue[100],
        backgroundColor: theme.colors.accent.blue[10],
        arrow: (
          <NoTrendIcon
            id="NoTrendIcon"
            data-testid="noTrendIcon"
            color={theme.colors.accent.blue[100]}
          />
        ),
        sign: '',
      }
    );
  }, [stateType, progress]);

  return (
    <ScoreTrendCont>
      <ScoreTrendContent
        mainColor={renderTrend.color}
        backgroundColor={renderTrend.backgroundColor}
        id="ScoreTrendCont"
        data-testid="scoreTrendCont"
        isBorderless={isBorderless}
      >
        {renderTrend.arrow}
        <Sign id="Sign">{renderTrend.sign}</Sign>
        {Math.abs(Math.floor(progress))}
      </ScoreTrendContent>
    </ScoreTrendCont>
  );
};

export default ScoreTrend;
